

var _squid = require('squid');

require('./directive');

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$BmlTermsAndConditionsRoute', function () {

    return _squid.$ComponentRoute.extend('BmlTermsAndConditionsRoute', {

        name: 'bmltermsandconditions',
        trackingData: {
            fptiState: 'ppc_termsandconditions',
            buzname: {
                'fullpage': {
                    'pagename': '%::ppc_termsandconditions',
                    'pagename2': '%::ppc_termsandconditions:member:hermes:',
                    'version': 'member:%:'
                }
            }
        },
        directive: 'xo-bml-terms-and-conditions-page',
        titleContent: 'applyForBml.bmlApplyHeadline',

        children: []

    });
});

_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-credit-components/src/bml-display/xo-bml-terms-and-conditions/route.js
// module id = ../node_modules/xo-credit-components/src/bml-display/xo-bml-terms-and-conditions/route.js
// module chunks = 0